import { cn } from '@seen/ui'
import { type HTMLAttributes, type JSX, useEffect, useState } from 'react'

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  delayMs?: number
}

export function Skeleton({
  className,
  delayMs,
  ...props
}: SkeletonProps): JSX.Element {
  const [didDelay, setDidDelay] = useState(false)
  const hideSkeleton = delayMs !== undefined && !didDelay

  useEffect(() => {
    if (delayMs !== undefined) {
      const timeoutId = setTimeout(() => setDidDelay(true), delayMs)
      return () => clearTimeout(timeoutId)
    }
    return undefined // Appease TS7030 (Not all code paths return a value)
  }, [delayMs])

  return (
    <div
      className={cn(
        !hideSkeleton &&
          'animate-pulse rounded-md bg-zinc-100 dark:bg-zinc-800',
        className
      )}
      {...props}
    />
  )
}
